import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const DashboardPage = lazy(() => import("./DashboardPage"));

const DashboardPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <DashboardPage />
    </Suspense>
  );
};

export default DashboardPageLazy;
